<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="微信支付" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 8}" :lg="{span: 8}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="开启支付"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
              <a-switch v-if="isEdit" checkedChildren="开" unCheckedChildren="关" v-model="defaultChecked" @change="enableChange"/>
              <span v-if="!isEdit && data.wxpay_enable === 'YES'">开启</span>
              <span v-if="!isEdit && data.wxpay_enable === 'NO'">关闭</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="商户号"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['weixin_mch_id',{rules: [{ required: true, message: '请输入商户号' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.weixin_mch_id || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="AppID"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['weixin_app_id',{rules: [{ required: true, message: '请输入AppID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.weixin_app_id || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="AppSecret"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['appSecret',{rules: [{ required: true, message: '请输入AppSecret' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.appSecret || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="支付密钥"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['weixin_pay_key',{rules: [{ required: true, message: '请输入支付密钥' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.weixin_pay_key || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="异步回调地址"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['weixin_pay_notify_url']"/>
              <a-input v-if="!isEdit" :disabled="true" v-model="data.weixin_pay_notify_url"/>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="支付证书"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-upload v-if="isEdit" name="file" action="/api/manage/v1/file/uploadFile?type=ATTRIBUTE" @change="handleKeyFileChange">
                <a-button>
                  <a-icon type="upload" /> 点击上传
                </a-button>
              </a-upload>
              <a-button size="small" v-if="!isEdit && !data.keyFile">未上传</a-button>
              <a-button size="small" v-if="!isEdit && data.keyFile">已上传</a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="支付证书密钥"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-upload v-if="isEdit" name="file" action="/api/manage/v1/file/uploadFile?type=ATTRIBUTE" @change="handleKeyPasswordFileChange">
                <a-button>
                  <a-icon type="upload" /> 点击上传
                </a-button>
              </a-upload>
              <a-button size="small" v-if="!isEdit && !data.keyPassword">未上传</a-button>
              <a-button size="small" v-if="!isEdit && data.keyPassword">已上传</a-button>
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import FooterToolBar from '@/components/FooterToolbar'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
    FooterToolBar
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {},
      defaultChecked: false
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'weixin' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
          if (this.data.wxpay_enable === 'YES') {
            this.defaultChecked = true
          }
        }
      })
    },
    enableChange (checked) {
      if (checked) {
        this.data.wxpay_enable = 'YES'
      } else {
        this.data.wxpay_enable = 'NO'
      }
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 图片上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const imgId = _.get(info.file, 'response.data.id')
        this.data[targetId] = imgId
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleKeyFileChange (info) {
      this.handleFileUpload(info, 'keyFile')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleKeyPasswordFileChange (info) {
      this.handleFileUpload(info, 'keyPassword')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
